import { CreditCard, Delete, Done, Edit, Person, Print } from "@mui/icons-material"
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material"
import React, { useEffect, useRef, useState } from "react"
import { CASTE_CODES, FEMALE, MALE, NO_RECORDS_FOUND, PRAKRITI, YOG_SEWA_VIVARAN } from "../../../../../utils/constants";
import { AppUtils } from "../../../../../utils/appUtils";
import { AppMisc } from "../../../../../misc/appMisc";
import { NEW_PATIENT, PREVIOUS_PATIENT } from "../../../../../utils/constants/forms";
import InfiniteScroll from "react-infinite-scroll-component";
import ReactToPrint from "react-to-print";

const TherapeuticYogaSewaRegister = ({ page, totalSize, ...props }) => {
  const [mainRegisterData, setMainRegisterData] = useState([]);
  const tableRef = useRef();

  useEffect(() => {
    if (props.tableData !== null) {
      if (page) {
        setMainRegisterData(prev => {
          return [...prev, ...props.tableData]
        })
      } else {
        tableRef.current.scrollTo(0, 0)
        setMainRegisterData(props.tableData)
      }
    }
  }, [props.tableData])

  const fetchData = () => {
    props.handleChangePage(page + 1);
    props.getTableData(true)
  }

  return (
    <>
      <InfiniteScroll
        dataLength={mainRegisterData?.length}
        next={fetchData}
        hasMore={mainRegisterData?.length !== totalSize}
        loader={<p style={{ textAlign: 'center' }} className="print-none">Loading....</p>}
        scrollableTarget="mul-dartaa-register"
      >
        <ReactToPrint
          trigger={() => (
            <Box display={"flex"} justifyContent={"flex-end"}>
              <IconButton>
                <Print />
              </IconButton>
            </Box>
          )}
          content={() => tableRef.current}
        />
        <TableContainer classes={{ root: "fixed-head-table-container" }} ref={tableRef}  >
          <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Mul Dartaa Register">
            <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
              <TableRow>
                <TableCell rowSpan={3}>क्र.सं.</TableCell>
                <TableCell rowSpan={3}>दर्ता मिति</TableCell>
                <TableCell colSpan={2}>दर्ता नम्बर</TableCell>
                <TableCell colSpan={2}>सेवाग्राहीको</TableCell>
                <Tooltip title=
                  {
                    <>
                      {CASTE_CODES.map(caste => (
                        <Typography key={caste.value} variant="caption"> {caste.label} </Typography>
                      ))}
                    </>
                  }
                  placement="top"
                  arrow
                >
                  <TableCell rowSpan={3}>जाती कोड</TableCell>
                </Tooltip>
                <TableCell colSpan={2}>उमेर</TableCell>
                <TableCell colSpan={4}>ठेगाना</TableCell>
                <TableCell rowSpan={2}>सम्पर्क नम्बर</TableCell>
                <TableCell rowSpan={2}>राष्ट्रिय परिचयपत्र नम्वर</TableCell>
                <TableCell rowSpan={2}>व्याधी</TableCell>
                <TableCell rowSpan={2}>प्रकृति</TableCell>
                <TableCell rowSpan={2}>योगको विवरण</TableCell>
                <TableCell rowSpan={2}>योगको नाम</TableCell>
                <TableCell rowSpan={3} className="print-none">सम्पादन</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>पहिलो पटक</TableCell>
                <TableCell>थप पटक</TableCell>
                <TableCell>नाम</TableCell>
                <TableCell>थर</TableCell>
                <TableCell>महिला</TableCell>
                <TableCell>पुरुष</TableCell>
                <TableCell>जिल्ला</TableCell>
                <TableCell>नगर/गाउँपालिका</TableCell>
                <TableCell>वडा नं.</TableCell>
                <TableCell>अन्य मुलुक</TableCell>
              </TableRow>
            </TableHead>
            <TableBody classes={{ root: "align-center" }}>
              {
                mainRegisterData?.length > 0 ? (
                  mainRegisterData?.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell>{AppUtils.replaceWithNepaliDigit(index + 1)}</TableCell>
                      <TableCell>{AppMisc.getDateLabelFromMillisecond(row?.dartaaMiti)}</TableCell>
                      <TableCell>{row?.patientType === NEW_PATIENT ? row?.mulDartaaNumber && AppUtils.replaceWithNepaliDigit(row.mulDartaaNumber) : "-"}</TableCell>
                      <TableCell>{row?.patientType === PREVIOUS_PATIENT ? row?.mulDartaaNumber && AppUtils.replaceWithNepaliDigit(row.mulDartaaNumber) : "-"}</TableCell>
                      <TableCell>{row?.patientFirstName || "-"}</TableCell>
                      <TableCell>{row?.patientLastName || "-"}</TableCell>
                      <TableCell>{row?.castCode && AppUtils.replaceWithNepaliDigit(row.castCode) || "-"}</TableCell>
                      <TableCell>{row?.gender === FEMALE ? row?.age && AppUtils.replaceWithNepaliDigit(row.age) : "-"}</TableCell>
                      <TableCell>{row?.gender === MALE ? row?.age && AppUtils.replaceWithNepaliDigit(row.age) : "-"}</TableCell>
                      <TableCell>{row?.district && AppMisc.getDistrictName(row?.district)}</TableCell>
                      <TableCell>{row?.palikaName && AppMisc.getMunicipalityName(row?.palikaName)}</TableCell>
                      <TableCell>{row?.wardNumber && AppUtils.replaceWithNepaliDigit(row?.wardNumber)}</TableCell>
                      <TableCell>{row?.otherCountry ? <Done /> : "-"}</TableCell>
                      <TableCell>{row?.phoneNumber && AppUtils.replaceWithNepaliDigit(row?.phoneNumber)}</TableCell>
                      <TableCell>{row?.nid || "-"}</TableCell>
                      <TableCell>{row.vyadhi || "-"}</TableCell>
                      <TableCell>{AppMisc.findLabelFromValue(PRAKRITI, row?.nature || "-")}</TableCell>
                      <TableCell>{AppMisc.findLabelFromValue(YOG_SEWA_VIVARAN, row.yogSewa || "-")}</TableCell>
                      <TableCell>{row.yogName || "-"}</TableCell>
                      <TableCell className="print-none">
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                          <IconButton aria-label="edit" onClick={() => props.onEditRow(row.id)}>
                            <Edit fontSize="small" />
                          </IconButton>
                          {/* <Tooltip title="स्वास्थ्य सेवा कार्ड हेर्न यहा क्लिक गर्नुहोस" placement="top" arrow>
                            <CreditCard fontSize="small" />
                          </Tooltip> */}
                          <Tooltip title="रेकर्ड हटाउन यहा क्लिक गर्नुहोस" placement="top" arrow>
                            <IconButton onClick={() => props.deleteRow(row.id)}>
                              <Delete fontSize="small" color="secondary" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="प्रोफाइल कार्ड हेर्न यहा क्लिक गर्नुहोस" placement="top" arrow>
                            <Box>
                              <a target="_blank" rel="noreferrer" href={`therapeutic-yog-sewa-vivaran?id=${row.id}`}>
                                <Person fontSize="small" />
                              </a>
                            </Box>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan="41" size="medium">{NO_RECORDS_FOUND}</TableCell>
                  </TableRow>
                )
              }
            </TableBody>
          </Table>
        </TableContainer>
      </InfiniteScroll>
    </>
  )
}

export default TherapeuticYogaSewaRegister;